import { render } from "./TextElement.vue?vue&type=template&id=9e0b840a&scoped=true"
import script from "./TextElement.vue?vue&type=script&lang=js"
export * from "./TextElement.vue?vue&type=script&lang=js"

import "./TextElement.vue?vue&type=style&index=0&id=9e0b840a&scoped=true&lang=css"

import exportComponent from "../../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e0b840a"]])

export default __exports__